export default {
  state: {
    isLoading: false,
    isLoadingData: false,
  },
  getters: {
    isLoading: state => state.isLoading,
    isLoadingData: state => state.isLoadingData,
  },
  mutations: {
    SET_IS_LOADING(state, payload) {
      state.isLoading = payload
    },
    SET_IS_LOADING_DATA(state, payload) {
      state.isLoadingData = payload
    },
  },
  actions: {
    setIsLoading({ commit }, payload) {
      commit('SET_IS_LOADING', payload)
    },
    setIsLoadingData({ commit }, payload) {
      commit('SET_IS_LOADING_DATA', payload)
    },
  },
}
